// Pure helpers for the Reservations page list/KPIs (GitHub issue #276).
//
// The Today / Upcoming / Past tabs used to be resolved by fetching a capped
// 200-row slice and filtering it client-side (`r.reservation_date > today` /
// `< today`). That undercounts the KPIs and hides reservations past the cap.
// These helpers turn a tab into server-side date filters so the API can scope,
// paginate, and aggregate the WHOLE set instead.

export interface TabDateFilters {
  date?: string;
  date_after?: string;
  date_before?: string;
}

/**
 * Map a tab to the server-side date filters that reproduce the original
 * semantics exactly: Today = the current calendar day, Upcoming = strictly
 * after today, Past = strictly before today.
 */
export function buildTabDateFilters(tab: string, today: string): TabDateFilters {
  if (tab === 'upcoming') return { date_after: today };
  if (tab === 'past') return { date_before: today };
  // 'today' (and any unknown tab) → the exact current day.
  return { date: today };
}

/**
 * Format the server's peak hour (0–23, or null when the set is empty) for the
 * KPI card. Preserves the display the page shipped with, e.g. 13 → "1:00 PM",
 * 9 → "9:00 AM".
 */
export function formatPeakHour(hour: number | null | undefined): string {
  if (hour === null || hour === undefined) return '—';
  const period = hour < 12 ? 'AM' : 'PM';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${displayHour}:00 ${period}`;
}
